module.exports = __webpack_public_path__ + "aa2a2b388ad8211f97612b975d6949b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pencil.png
// module id = 2867
// module chunks = 0